import { type QueryHookOptions, useQuery } from "@apollo/client";
import { StreamsListQuery } from "../graphql/queries";
import type {
  StreamsListQueryType,
  StreamsListQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useStreamsListQuery = (
  options?: QueryHookOptions<
    StreamsListQueryType,
    StreamsListQueryVariablesType
  >
) => {
  return useQuery<StreamsListQueryType, StreamsListQueryVariablesType>(
    StreamsListQuery,
    options
  );
};
